<div>
  <app-dialogs-filter
    (search)="searchDialogs($event)">
  </app-dialogs-filter>
  <mat-divider></mat-divider>
  <app-dialogs-table *ngIf="dialogs"
    [dialogs]="dialogs.content"
    [page]="dialogs.number"
    [pageSize]="dialogs.size"
    [totalElements]="dialogs.totalElements"
    (loadDialogs)="loadDialogs($event)">
  </app-dialogs-table>
</div>
